var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsOtherResultDescription = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8333 18.3333H4.16667C3.24583 18.3333 2.5 17.5875 2.5 16.6667V3.33332C2.5 2.41249 3.24583 1.66666 4.16667 1.66666H15.8333C16.7542 1.66666 17.5 2.41249 17.5 3.33332V16.6667C17.5 17.5875 16.7542 18.3333 15.8333 18.3333Z",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.5H5",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10512 15.4167H5",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58881 7.94165L7.59123 8.46819C7.78652 8.57083 8.01446 8.40487 7.97714 8.18759L7.78585 7.0712L8.59698 6.2814C8.75495 6.12743 8.66763 5.8595 8.44969 5.82751L7.32863 5.66488L6.82742 4.64846C6.73011 4.45051 6.44751 4.45051 6.3502 4.64846L5.84899 5.66488L4.72793 5.82817C4.50999 5.8595 4.42268 6.1281 4.58064 6.28206L5.39177 7.07187L5.20048 8.18826C5.16316 8.40554 5.3911 8.5715 5.58639 8.46886L6.58881 7.94165Z",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsOtherResultDescription);
export default ForwardRef;